import mqtt from 'mqtt';
import { decodeWinData } from './win_light'
import SmoothieComponent, { TimeSeries } from 'react-smoothie';
import { useEffect, useState } from 'react';
//import css from "./index.module.css";

export default function Realtimegraph(props) {
  const [message, setMessage] = useState(null);
  const [warntime, setwarntime] = useState(0);
  const [ts1, setts1] = useState(new TimeSeries({}));
  const [ts2, setts2] = useState(new TimeSeries({}));
  const [ts3, setts3] = useState(new TimeSeries({}));
  const [ave1, setave1] = useState(null);
  const [ave2, setave2] = useState(null);
  const [ave3, setave3] = useState(null);

  function yRange(range) {
    let rng = (range.max - range.min);
    let ctr = (range.max + range.min) / 2;
    let h = props.yRangeFunction(props.sid + "_" + props.no, rng);
    return { min: ctr - h / 2, max: ctr + h / 2 };
  }

  useEffect(() => {
    const client = mqtt.connect('wss://mqtt.yuremon.com:443/mqtt');
    client.on('connect', () => {
      client.subscribe(props.uid + '/' + props.sid + '/#', (err) => {
        if (err) {
          console.error('Subscription error:', err);
        }
      });
    });
    client.on('message', (topic, message) => {
      setMessage({ topic, message });
    });
    return () => {
      if (client.connected) {
        client.end();
      }
    };
  }, []);


  useEffect(() => {
    if (message) {
      if (message.topic.match('/MOT')) {
        let rate = message.message[13];
        let winObj = decodeWinData(message.message, rate);
        if (props.win) props.win(winObj);
        let current = winObj.time;
        ts1.resetBounds();//静的ビルドでは何故か呼ばれないため
        ts2.resetBounds();
        ts3.resetBounds();
        let ave1t = ave1;
        let ave2t = ave2;
        let ave3t = ave3;
        let no = (props.no) ? props.no : 0;
        if (no in winObj.accX) {
          for (var i = 0; i < winObj.accX[no].length; i++) {
            ave1t = (ave1t == null) ? winObj.accX[no][i] : ave1t * 0.98 + winObj.accX[no][i] * 0.02;
            ave2t = (ave2t == null) ? winObj.accY[no][i] : ave2t * 0.98 + winObj.accY[no][i] * 0.02;
            ave3t = (ave3t == null) ? winObj.accZ[no][i] : ave3t * 0.98 + winObj.accZ[no][i] * 0.02;
            ts1.append(current, winObj.accX[no][i] - ave1t);
            ts2.append(current, winObj.accY[no][i] - ave2t);
            ts3.append(current, winObj.accZ[no][i] - ave3t);
            current += (1000 / rate);
          }
        }
        setave1(ave1t);
        setave2(ave2t);
        setave3(ave3t);
        setts1(ts1);
        setts2(ts2);
        setts3(ts3);
        if (props.recievewinFunction) {
          let win = { accX: [], accY: [], accZ: [] };
          win.accX[0] = winObj.accX[no];
          win.accY[0] = winObj.accY[no];
          win.accZ[0] = winObj.accZ[no];
          props.recievewinFunction(props.sid + "_" + no, win);
        }
      } else if (message.topic.match('/WARN/VIB')) {
        setwarntime((new Date()).getTime());
      }
    }
  }
    , [message])
  //    <div className={css.subtitle}>{props.name ? props.name : props.uid + '/' + props.sid + '/#'}</div>


  const seriesList = [
    {
      name: 'X',
      color: 'rgb(255, 105, 180)', // hot pink
      data: ts1,
    },
    {
      name: 'Y',
      color: 'rgb(0, 255, 154)', // medium spring green
      data: ts2,
    },
    {
      name: 'Z',
      color: 'rgb(135, 206, 250)', // light sky blue
      data: ts3,
    },
  ];
  const timeFormatter = (timestamp) => {
    const date = new Date(timestamp);
    // 例: 'HH:mm:ss' 形式で表示
    return date.toLocaleTimeString('ja-JP');
  };
  return (
    <div style={(new Date()).getTime() - warntime < 10 * 1000 ? { borderColor: "red", borderStyle: "solid", borderWidth: "4px"} : {}}>
      <div style={{ display: 'flex', alignItems: 'center',padding: "1px" }}>
        <div style={{ width: '1em', display: 'flex', alignItems: 'center', justifyContent: 'center', height: props.height}}>
          <div style={{ transform: 'rotate(-90deg)', textAlign: 'center', fontSize: '1em', color: '#333', whiteSpace: 'nowrap' }}>
            加速度(Gal)
          </div>
        </div>
        <div style={{ position: "relative", flexGrow: 1 }}>
          <SmoothieComponent
            yRangeFunction={yRange}
            responsive={true}
            height={props.height}
            millisPerPixel={12 * 6}
            grid={{ fillStyle: '#999999', millisPerLine: 10 * 1000, lineWidth: 0.25, strokeStyle: '#333333' }}
            streamDelay={1000}
            series={[...seriesList].reverse().map(s => ({
              data: s.data,
              strokeStyle: s.color,
              lineWidth: 1
            }))}
            timestampFormatter={timeFormatter}
          />
          <div style={{position: 'absolute', top: 5, left: 5, color: 'white', fontSize: '1.2em'}}>{props.name ? props.name : props.uid + '/' + props.sid + '/#'}</div>
          <div
            style={{
              position: 'absolute',
              bottom: 5,
              left: 5,
              pointerEvents: 'none',
              fontSize: 12,
              color: 'white',
              backgroundColor: 'rgba(0,0,0,0.25)',
              padding: '2px 6px',
              borderRadius: 4,
              display: 'flex',           // 横並びにする
              flexDirection: 'column',
              gap: '0px',               // 項目間の間隔
              alignItems: 'center',      // 垂直方向の中央揃え
            }}
          >
            {seriesList.map((s, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: 10,
                    height: 2,
                    backgroundColor: s.color,
                    marginRight: 4,
                  }}
                ></span>
                <span>{s.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

